/**
 * 导入导出任务列表
 **/

import React from 'react';
import {Button, message, Tag,Tooltip} from 'antd';
import {fetchTasks} from "../../redux/actions/attendee";
import {cancelTasks} from "../../services/attendee";
import CKDataTablePage2 from '../../components/CKDataTablePage2';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {antdTableColumnsMerge} from "../../utils/index";
import PropTypes from "prop-types";

class TaskList extends React.Component {
    constructor(props) {
        console.log(props)
        super(props);
        this.ckDataTablePage = null;
        this.state = {
            userId: props.userId,
            eventId:props.eventId,
            searchParams: Object.assign({}, {
                type: props.type,
            }, this.props.tasks.searchParams),
            selectedRowKeys: [],
            selectedRecords: [],
            listenerNtfs: [
                "EVENT_ATTENDEE_IMT_NTF",
                "EVENT_INVITEE_IMT_NTF",
                "EVENT_ATTENDEE_EXP_NTF",
                "USER_CONTACT_IMP_NTF",
                "USER_CONTACT_EXP_NTF",
                "EVENT_ATTENDEE_QRCODE_EXT_NTF",
                "EVENT_ATTENDEE_CHECKIN_COUNT_EXT_NTF",
                "EVENT_REPORT_TAIL_SINGIN_EXP_NTF",
                "EVENT_ATTENDEE_COLLECT_COUNT_EXT_NTF",
                "EVENT_PRICE_DRAW_EXP_NTF",
                "EVENT_PRICE_ROLL_EXP_NTF",
                "EVENT_ALLOT_EXP_NTF",
                "EVENT_ATTENDEE_PIC_NTF",
                "EVENT_ATTENDEE_FILE_NTF",
                "SURVEY_EXP_NTF",
                "VOTE_EXP_NTF",
                "LUCKYMONEY_EXP_NTF",
                "EVENT_REPORT_SINGUP_EXP_NTF",
                "EVENT_REPORT_SINGIN_EXP_NTF",
                "EVENT_ATTENDEE_BADGE_EXT_NTF",
                "EVENT_CHECKIN_LOG_EXP_NTF",
                "EVENT_ORDER_EXP_NTF",
                "EVENT_ATTENDEE_FROM_CONTACT_IMT_NTF",
                "EVENT_ATTENDEE_INVOICE_EXT_NTF",
                "EVENT_LEVEL_SHARE_EXP_NTF",
                "EVENT_CODE_SHARE_EXP_NTF",
                "EVENT_CHECKIN_CREDIT_EXP_NTF",
                "EVENT_WJW_MAKE_EXP_NTF",
                "GUEST_GROUP_EXP_NTF",
                "LEAP_EVENT_EXP_NTF",
                "EVENT_CODE_SHARE_IMT_NTF",
                "EVENT_ATTENDEE_INFO_QRCODE_EXT_NTF",
                "EVENT_PDF_DIPLOMA_EXT_NTF",
            ],
            columns: antdTableColumnsMerge([
                {
                    title: '创建时间',
                    dataIndex: 'createTime',
                    fixed: false

                },
                {title: '状态', dataIndex: '',
                    render:(text,record,index)=>(
                        <span>
                            {(record.type == 'ATTENDEEIMP' || record.type == 'INVITATIONIMP' || record.type == 'CONTACTIMP' || 
                              record.type =='ALLOT_IMP' || record.type =='ATTENDEE_CONTACT_IMP' || record.type =='EVENT_CODE_SHARE_IMP') ?
                                <span>
                                    {record.status == 'RUNNING' && <Tag color="#ffbf00">导入中</Tag>}
                                    {record.status == 'CANCELLED' && <Tag color="#d9d9d9">已取消</Tag>}
                                    {record.status == 'SUCCESS' && <Tag color="#87d068">导入成功</Tag>}
                                    {record.status == 'FAILED' && <Tag color="#f50">导入失败</Tag>}
                                </span> :
                            <span>
                                {record.status == 'RUNNING' && <Tag color="#ffbf00">导出中</Tag>}
                                {record.status == 'CANCELLED' && <Tag color="#d9d9d9">已取消</Tag>}
                                {record.status == 'SUCCESS' && <Tag color="#87d068">导出成功</Tag>}
                                {record.status == 'FAILED' && <Tag color="#f50">导出失败</Tag>}
                            </span>}
                        </span>
                    )},
                {title: '备注', dataIndex: 'remarks',render:(text,record,index)=>(
                    <Tooltip  title={record.remarks}  mouseEnterDelay={0.3}>
                      <span>{record.remarks}</span>
                    </Tooltip>
                )},
                {title: '操作', width:120, dataIndex: '',
                    render:(text,record,index)=>(
                        <span>
                            {record.fileName && record.status == 'SUCCESS' &&
                            <a href={record.fileName} download>下载</a>}
                            {record.status == 'RUNNING' &&
                            <a href='#' onClick={()=>this.cancelAttendeeTask(record)}>取消任务</a>}
                        </span>
                    )},


            ], (this.props.tasks.extra && this.props.tasks.extra.columns) ? this.props.tasks.extra.columns : [])

        }
        console.log("oids", props);

    }
    componentWillUnmount() {
        this.state.listenerNtfs.forEach(item => {
            this.context.getCkSocket().removeWsMsgListener(item, this.newImportHandle);
        });
    }
    componentDidMount() {
        this.state.listenerNtfs.forEach(item => {
            this.context.getCkSocket().addWsMsgListener(item, this.newImportHandle);
        });
    }
    componentWillReceiveProps(nextProps) {
        if ((nextProps.type && this.state.searchParams.type != nextProps.type) || (nextProps.eventId && this.state.eventId != nextProps.eventId)) {
            console.log('ok')
            this.setState({
                eventId:nextProps.eventId,
                searchParams:{
                    type: nextProps.type
                }
            }, () => {
                this.ckDataTablePage.fetchTableData();
            });
        }
    }
    newImportHandle = (msg) => {
        // 导入成功 刷新数据
        if (msg && this.ckDataTablePage) {
            this.ckDataTablePage.fetchTableData();
        }
    }
    handleTableRowsSelectChange = (selectedRowKeys, selectedRecords) => {
        this.setState({selectedRowKeys, selectedRecords});
    };

    fetchData = (params, pagination = this.props.pagination, sort = this.props.sort) => {
        const searchParams = Object.assign(params, {userId:this.state.userId}, {eventId: this.state.eventId});
        this.props.fetchTasks(searchParams, pagination, sort, {columns: this.state.columns});
    };

    fetchFilterTableData() {
        this.ckDataTablePage.fetchTableData();

    }
    searchParamsChange(propName, val, invokingFetchFilterTableData = true) {
        const searchParams = {...this.state.searchParams};
        searchParams[propName] = val;
        this.setState({
            searchParams: searchParams,
        }, () => {
            if (invokingFetchFilterTableData) {
                this.fetchFilterTableData();
            }
        });
    }
    handleTableColumnsChange = (columns) => {
        this.setState({
            columns: columns
        })
    };
    //取消任务
    cancelAttendeeTask = (record)=>{
        cancelTasks({eventId:record.eventId,taskId:record.id}).then(res => {
            if (res.code == 200) {
                message.info("已取消!");

            } else {
                message.error(res.msg,6);
            }
        }).catch(err => {
            message.warn("访问异常");
        })
    }
    render() {
        const ckDataTableToolbarLeft =
            <div>
                <Button type="primary" onClick={()=>this.fetchFilterTableData()}>
                    刷新
                </Button>
            </div>


        return (
            <CKDataTablePage2
                ref={(tbpage) => {
                    this.ckDataTablePage = tbpage
                }}
                comp={this}
                className={['contactstyle','hideborder']}
                tableScroll={{x:800,y:'calc(100vh - 450px)'}}
                // tableRowSelectionActions={ckDataTablerRowSelectionActions}
                toolbarLeft={ckDataTableToolbarLeft}
                tableRowKey={record => record.id}
                tableColumns={this.state.columns}
                tableSelectedRowKeys={this.state.selectedRowKeys}
                tableSelectedRowKeysChange={this.handleTableRowsSelectChange}
                tableDataSource={this.props.tasks}
                tableDataSourceFetch={this.fetchData}
                tableDataSourceFetchSearchParams={this.state.searchParams}
                tableColumnsChange={this.handleTableColumnsChange}
                reloadOnMount={this.props.lastLocation == null || this.props.lastLocation.action != "POP"}
                tableRowSelectDisabled={false}
                tableColumnsControlDisable={true}>
            </CKDataTablePage2>
        )
    }
}

TaskList.contextTypes = {
    getCkSocket: PropTypes.func
};
const mapStateToPorps = state => {
    const tasks = state.tasks;
    const cmEnums = state.cmEnums;
    const {lastLocation} = state.global;
    return {tasks,cmEnums, lastLocation};
};
const mapDispatchToProps = dispatch => ({
    fetchTasks: bindActionCreators(fetchTasks, dispatch),
});

export default connect(mapStateToPorps, mapDispatchToProps)(TaskList);


// WEBPACK FOOTER //
// ./src/containers/tasklist/TaskList.jsx